import { SettingTwoTone } from "@ant-design/icons";
import { Flex, Result } from "antd";
import { t } from "i18next";
import style from "./MaintenancePage.module.scss";
const MaintenancePage = () => {
  return (
    <Flex align="center" justify="center" style={{ height: "100vh" }}>
      <Result
        icon={<SettingTwoTone className={style.spin} />}
        title={t("MAINTENANCE.TITLE")}
        subTitle={t("MAINTENANCE.SUB_TITLE")}
      />
    </Flex>
  );
};

export default MaintenancePage;
